
export const DEFAULT_MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
